module.exports = __webpack_public_path__ + "media/images/icons/108__medal2-86eb86d981554e77193426450a0b3501.svg";